module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAPCAMAAADNjy/UAAAAS1BMVEUAAAAzuEc4xFA4xFA5xFA4xFE4xFA4w1A4xFA4w082wk44xFA4w1A4xE85xFE3w083xFA4xFA4xE84wlA4w085wU8xwkk4w1E5xFHVHOj2AAAAGHRSTlMADPXwxsC3qV1PQsycit+TfnhtaTctFdDdt1jLAAAAfUlEQVQY03WPWQ7DIAwFDYSEJfvWuf9JqwpFJNC8H481kuUn9nPKn5zRykhUtVGRUQ6DVZWxmENk17SlatH7bwbonqaDkMhDfzcT+IsdDNkM4PK2wnLxAqvcMsOWaIM5UXnFwSRFevD5o/JjHYJOPeqexqT2VVQDjZIX9zBff2cGaOJTA/AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/more_blue_dwon.png
// module id = 70
// module chunks = 0